export default __webpack_public_path__ + "static/media/life-insurance-hero.e9fb3d63.jpg";